const getPaymentStripeLink = (state: any) =>
  state.getIn(['paymentSettings', 'data', 'url']);

export default getPaymentStripeLink;
